import { LANGS, getUiLang, setUiLang } from "@/lib/i18n";
import { api } from "@/lib/api";
import { tr } from "@/lib/i18n";

export const LangSwitch = ({ loggedIn = false, dark = false }) => {
  const cur = getUiLang();
  const pick = async (l) => {
    if (l === cur) return;
    if (loggedIn) await api.put("/auth/lang", { lang: l }).catch(() => {});
    setUiLang(l, !loggedIn);
  };
  return (
    <div className={`flex items-center rounded-full p-0.5 text-[11px] font-tech ${dark ? "bg-white/10" : "bg-slate-100"}`} title={tr("Lingua")} data-testid="lang-switch">
      {LANGS.map(([k, l]) => (
        <button key={k} type="button" onClick={() => pick(k)} data-testid={`lang-${k}`}
          className={`px-2.5 py-1 rounded-full transition-colors ${cur === k ? "bg-[#0F52BA] text-white" : dark ? "text-white/70 hover:text-white" : "text-slate-500 hover:text-slate-900"}`}>{l}</button>
      ))}
    </div>
  );
};
